export function pluralize(key: string): string {
  return `${key}_plural`;
}
